import React from "react"
import PropTypes from 'prop-types'
import {useDispatch, useSelector} from "react-redux"

import {onChange} from "../../../../redux/addMember/addMemberAction"
import CheckboxInput from "../../../../components/form/checkboxInput"
import AlertCategory from "../../alertCategory/alertCategory"
import Tab from "../../../../components/Tab/Tab"


const YourData = ({pageActive, index, onNext, onPrev}) => {
    const dispatch = useDispatch()
    const {information} = useSelector(({addMemberReducer}) => addMemberReducer)
    
    const onClickNext = (e) => {
        e.preventDefault()

        if(information.registered_cvg.value === true || information.registered_cvg.value === "1") {
            onNext()
        }
    }

    return (
        <Tab pageActive={pageActive} index={index}>
        <div className={"content yourData col-10 mx-auto txt-left"}>
            <AlertCategory/>
        
            <p className={"title"}>How we use your data ?</p>

            <p className={"small"}>
                The Union will use the personal data from this form only in direct relation to your attendance at the 51st Union World Conference on Lung Health in Seville (such as, for registration, programme updates and the mobile app). We will not share your data for any commercial reason.
            </p>
            <p className={"small"}>
                Please note: During the conference, exhibitors may ask if they can scan your badge. If your badge is scanned, certain details of your registration profile will be shared with the exhibitor. Be aware that by allowing your badge to be scanned you consent to sharing this information.
            </p>
            <p className={"small"}>
                By entering the event premises, delegates give their permission to be photographed or recorded by official photographers, videographers and attending media of the 51st Union World Conference on Lung Health. Delegates consent to their images and video being reproduced for subsequent use in the media, webcasts, internal and external promotional purposes, advertising and inclusion on websites and social media. Images are shared publicly with open access for use.
            </p>
            <p className={"small"}>
                This is in line with The Union's Privacy Policy. You can change your details or this consent at any time by emailing <a href={"mailto:privacy@theunion.org"}>privacy@theunion.org</a>.
            </p>

            <CheckboxInput placeholder={"I understand this is how The Union will use my data"}
                           onChange={e => dispatch(onChange(e, true))}
                           name={"registered_cvg"}
                           value={information.registered_cvg.value}/>


            <div className={"content-footer"}>
                <button className={"sr-btn-next btn btn-secondary"} onClick={onPrev}>Previous</button>
                <button className={"sr-btn-next btn btn-info"} disabled={information.registered_cvg.value === false || information.registered_cvg.value === "0"} onClick={onClickNext}>Next</button>
            </div>
        </div>
        </Tab>
    )
}

YourData.propTypes = {
    prevTab: PropTypes.func.isRequired,
    nextTab: PropTypes.func.isRequired,
}

export default YourData
